import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import getConfig from '../../../../../../lib/config';
import { useFeature } from '../../../../../core/src/components/LaunchDarkly';

const REACT_APP_ENV = process.env.REACT_APP_ENV;

const REACT_APP_VIRTUAL_HUMAN_BUILD_URI_DEV = getConfig(
  'REACT_APP_VIRTUAL_HUMAN_BUILD_URI_DEV'
);
const REACT_APP_VIRTUAL_HUMAN_BUILD_URI_PROD = getConfig(
  'REACT_APP_VIRTUAL_HUMAN_BUILD_URI_PROD'
);
const REACT_APP_VIRTUAL_HUMAN_BUILD_URI_2022 = getConfig(
  'REACT_APP_VIRTUAL_HUMAN_BUILD_URI_2022'
);
const REACT_APP_VIRTUAL_HUMAN_BUILD_BASE_URL = getConfig(
  'REACT_APP_VIRTUAL_HUMAN_BUILD_BASE_URL'
);

export const useVHUnityUrl = () => {
  const [unityBuildPathFeature] = useFeature(['vh-unity-build-path']);
  const { search } = useLocation();
  const url = useMemo(() => {
    if (unityBuildPathFeature) {
      return `${REACT_APP_VIRTUAL_HUMAN_BUILD_BASE_URL}${unityBuildPathFeature}/`;
    }
    const params = new URLSearchParams(search);

    if (params.get('unitydevbuild') === 'true') {
      return REACT_APP_VIRTUAL_HUMAN_BUILD_URI_DEV;
    }
    if (params.get('unityprodbuild') === 'true') {
      return REACT_APP_VIRTUAL_HUMAN_BUILD_URI_PROD;
    }

    if (REACT_APP_ENV === 'production') {
      return REACT_APP_VIRTUAL_HUMAN_BUILD_URI_PROD;
    }

    return REACT_APP_VIRTUAL_HUMAN_BUILD_URI_DEV;
  }, [unityBuildPathFeature, search]);

  return url;
};

export default useVHUnityUrl;
